/* Flipping the theme. The attribute on <html> is the single source of truth; useTheme reads it. */
import { fx } from './fx.js';

/**
 * Flip the theme; `{ wipe: true, from: element }` radiates the new theme from that element. Persists to localStorage("gryd-theme").
 *
 * @param {'light'|'dark'} next
 * @param {{ wipe?: boolean, from?: Element|null }} [opts]
 */
export function applyTheme(next, opts = {}) {
  const html = document.documentElement;
  if (opts.wipe && opts.from && fx.theme && document.startViewTransition) { fx.theme(next, opts.from); return; }
  if (opts.wipe && opts.from) {
    const r = opts.from.getBoundingClientRect();
    document.body.style.setProperty('--wipe-x', (r.left + r.width / 2) + 'px');
    document.body.style.setProperty('--wipe-y', (r.top + r.height / 2) + 'px');
    document.body.classList.remove('mo-wipe'); void document.body.offsetWidth; document.body.classList.add('mo-wipe');
    setTimeout(() => document.body.classList.remove('mo-wipe'), 420);
  } else {
    html.classList.add('theme-transition'); setTimeout(() => html.classList.remove('theme-transition'), 300);
  }
  html.setAttribute('data-theme', next);
  try { localStorage.setItem('gryd-theme', next); } catch (e) {}
}
